import React, { useEffect } from 'react';
import { styled } from '@compiled/react';
import { useQueryLoader } from 'react-relay';
import { token } from '@atlaskit/tokens';
import PageHeader from '@atlassian/jira-common-components-page-header';
import { useIntl } from '@atlassian/jira-intl';
import PROJECT_NAME_QUERY_AGG, {
	type mainArcivedIssuesProjectNameQuery,
} from '@atlassian/jira-relay/src/__generated__/mainArcivedIssuesProjectNameQuery.graphql';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useRouter } from '@atlassian/react-resource-router';
import { ArchiveIssueBreadcrumbs } from './breadcrumbs/main.tsx';
import messages from './messages';

interface ArchiveIssuePageHeaderProps {
	bottomBar: React.ReactNode;
}

const ArchiveIssuePageHeader: React.FC<ArchiveIssuePageHeaderProps> = ({ bottomBar }) => {
	const { formatMessage } = useIntl();
	const [{ match }] = useRouter();
	const cloudId = useCloudId();
	const projectKey = match.params.projectKey || '';
	const [queryReference, loadQuery] =
		useQueryLoader<mainArcivedIssuesProjectNameQuery>(PROJECT_NAME_QUERY_AGG);

	useEffect(() => {
		loadQuery({ projectKey, cloudId });
	}, [loadQuery, projectKey, cloudId]);

	return (
		<HeaderWrapper>
			<PageHeader
				breadcrumbs={
					queryReference && (
						<ArchiveIssueBreadcrumbs queryReference={queryReference} projectKey={projectKey} />
					)
				}
				bottomBar={bottomBar}
			>
				{formatMessage(messages.issueArchiveTitle)}
			</PageHeader>
		</HeaderWrapper>
	);
};

export default ArchiveIssuePageHeader;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderWrapper = styled.div({
	padding: `0 ${token('space.500', '40px')} 0`,
});
